import { useApi } from '@src/app/context/Api';
import { AssignmentsTable } from '@src/entities/ActionPath/ui/components/tables/Assignments';
import { TrustedSourcesTable } from '@src/entities/RiskRecord/ui/components/tables/TrustedSources';
import { UntrustedSourcesTable } from '@src/entities/RiskRecord/ui/components/tables/UntrustedSources';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { config } from '@uhg-abyss/web/tools/config';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Link } from '@uhg-abyss/web/ui/Link';
import { isUndefined } from 'lodash';
import React, { useEffect } from 'react';

import { Skeleton } from './components/Skeleton';

/**
 * ExpansionRow
 *
 * Expands a table row on click.
 *
 * @param row
 * @returns {Element}
 * @constructor
 */
export function ExpansionRow({ row = {} }) {
  const { useApiQuery } = useApi('RiskRecord');

  const [GetRiskRecord, { data, isFetching, isLoading }] = useApiQuery('GetRiskRecord');

  /**
   * Fetches additional data about the risk record when the row is expanded/opened.
   */
  useEffect(() => {
    if (isUndefined(data)) {
      GetRiskRecord({ eid: row?.eid });
    }
  }, [row]);

  if (isUndefined(data) || isLoading || isFetching) {
    return <Skeleton />;
  }

  return (
    <ErrorHandler location="src/entities/RiskRecord/ui/components/tables/RiskRecords/components/ExpansionRow/ExpansionRow.jsx">
      <Grid css={{ margin: 0 }}>
        <Grid.Col
          span={{
            xs: '100%',
          }}
        >
          <Heading offset={2}>Record View</Heading>
          <p>
            <strong>EID:</strong>{' '}
            <Link href={`${config('HCM_URL')}/${row?.eid}/`} openNewWindow>
              {row?.eid}
            </Link>
          </p>
        </Grid.Col>
        <Grid.Col
          span={{
            xs: '50%',
          }}
        >
          <AssignmentsTable record={data} row={row} />
        </Grid.Col>
        <Grid.Col
          span={{
            xs: '25%',
          }}
        >
          <TrustedSourcesTable record={data} row={row} />
        </Grid.Col>
        <Grid.Col
          span={{
            xs: '25%',
          }}
        >
          <UntrustedSourcesTable record={data} row={row} />
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
